export default __webpack_public_path__ + "static/media/sort_arrow.2e9ecd8e.svg";